import { render, staticRenderFns } from "./DialogEmpresas.vue?vue&type=template&id=bea86220&scoped=true&"
import script from "./DialogEmpresas.vue?vue&type=script&lang=js&"
export * from "./DialogEmpresas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea86220",
  null
  
)

export default component.exports